import React, {useEffect} from 'react';
import { AppRoutes } from "./routes";
import { Provider } from "react-redux";
import { ToastContainer} from "react-toastify";
import {store} from './redux/store';
import './App.scss';
import {CustomRouter} from "./components/CustomRouter";
import customHistory from "./components/RouteHistory";


const BaseToast = (props: any) => (
    <ToastContainer style={{ zIndex: "1900" }} {...props} />
);

function App() {

    // useEffect(() => {
    //     // Apply the 80% scaling to the root element
    //     document.documentElement.style.transform = 'scale(0.8)';
    //     return () => {
    //         // Reset the scaling when the component unmounts
    //         document.documentElement.style.transform = 'scale(1)';
    //     };
    // }, []);
    return (
        <CustomRouter history={customHistory}>
            <Provider store={store}>
                <div className="app-main zoom-80">
                    <BaseToast />
                    <AppRoutes/>
                </div>
            </Provider>
        </CustomRouter>
    );

}

export default App;
